/*
La respuesta de la web es:

{
  "type": "model_json",
  "errors": {
    "fecha_inicio": [
      "no puede estar en blanco",
      "no es una fecha"
    ],
    "fecha_fin": [
      "no es una fecha"
    ]
  }
}
*/
export function getModelJsonErrors(json) {
  if (json.type !== 'model_json') {
    return {};
  }
  return json.errors;
}

/* Devuelve los errores pero en vez de un array de errores, solo uno con todos los textos juntos */
export function getModelJsonUniqueErrors(json) {
  const errors = getModelJsonErrors(json);
  Object.keys(errors).forEach((key) => {
    errors[key] = errors[key].join(', ');
  });
  return errors;
}

export function modelErrorsToHtmlText(errors, separador = '. ') {
  if (!Array.isArray(errors)) {
    return errors;
  }
  return errors.join(separador);
}
